import loadable from 'react-loadable'
import { PageLoading } from '~components/PageLoading'

export const AsyncPasswordEmailSend = loadable({
  loader: () =>
    import('./PasswordEmailSend').then(
      ({ PasswordEmailSendPage }) => PasswordEmailSendPage,
    ),
  loading: PageLoading,
})

export const AsyncNewPasswordEmailSend = loadable({
  loader: () =>
    import('./NewPasswordEmailSend').then(
      ({ NewPasswordEmailSendPage }) => NewPasswordEmailSendPage,
    ),
  loading: PageLoading,
})

export const AsyncSingleAuth = loadable({
  loader: () =>
    import('./SingleAuth/SingleAuth').then(({ SingleAuth }) => SingleAuth),
  loading: PageLoading,
})

export const AsyncPasswordlessIdentify = loadable({
  loader: () =>
    import('./PasswordlessIdentify').then(
      ({ PasswordlessIdentifyPage }) => PasswordlessIdentifyPage,
    ),
  loading: PageLoading,
})

export const AsyncPasswordlessAccessCode = loadable({
  loader: () =>
    import('./PasswordlessAccessCode').then(
      ({ PasswordlessAccessCodePage }) => PasswordlessAccessCodePage,
    ),
  loading: PageLoading,
})

export const AsyncPasswordlessReview = loadable({
  loader: () =>
    import('./PasswordlessReview').then(
      ({ PasswordlessReviewPage }) => PasswordlessReviewPage,
    ),
  loading: PageLoading,
})

export const AsyncPasswordIdentify = loadable({
  loader: () =>
    import('./PasswordIdentify').then(
      ({ PasswordIdentifyPage }) => PasswordIdentifyPage,
    ),
  loading: PageLoading,
})

export const AsyncPasswordEnter = loadable({
  loader: () =>
    import('./PasswordEnter').then(
      ({ PasswordEnterPage }) => PasswordEnterPage,
    ),
  loading: PageLoading,
})

export const AsyncNewPassword = loadable({
  loader: () =>
    import('./NewPassword').then(({ NewPasswordPage }) => NewPasswordPage),
  loading: PageLoading,
})

export const AsyncNewPasswordValidate = loadable({
  loader: () =>
    import('./NewPasswordValidade').then(
      ({ NewPasswordValidatePage }) => NewPasswordValidatePage,
    ),
  loading: PageLoading,
})

export const AsyncCreateNewPassword = loadable({
  loader: () =>
    import('./CreateNewPassword').then(
      ({ CreateNewPasswordPage }) => CreateNewPasswordPage,
    ),
  loading: PageLoading,
})

export const AsyncCreateNewPasswordValidate = loadable({
  loader: () =>
    import('./CreateNewPasswordValidate').then(
      ({ CreateNewPasswordValidatePage }) => CreateNewPasswordValidatePage,
    ),
  loading: PageLoading,
})

export const AsyncSuccessCreatePassword = loadable({
  loader: () =>
    import('./SuccessCreatePassword').then(
      ({ SuccessCreatePasswordPage }) => SuccessCreatePasswordPage,
    ),
  loading: PageLoading,
})

export const AsyncInvalidCreatePassword = loadable({
  loader: () =>
    import('./InvalidCreatePassword').then(
      ({ InvalidCreatePasswordPage }) => InvalidCreatePasswordPage,
    ),
  loading: PageLoading,
})

export const AsyncInvalidRecoveryPassword = loadable({
  loader: () =>
    import('./InvalidRecoveryPassword').then(
      ({ InvalidRecoveryPasswordPage }) => InvalidRecoveryPasswordPage,
    ),
  loading: PageLoading,
})

export const AsyncSignupIdentify = loadable({
  loader: () =>
    import('./SignupIdentify').then(
      ({ SignupIdentifyPage }) => SignupIdentifyPage,
    ),
  loading: PageLoading,
})

export const AsyncSignupDocument = loadable({
  loader: () =>
    import('./SignupDocument').then(
      ({ SignupDocumentPage }) => SignupDocumentPage,
    ),
  loading: PageLoading,
})

export const AsyncSignupEmail = loadable({
  loader: () =>
    import('./SignupEmail').then(({ SignupEmailPage }) => SignupEmailPage),
  loading: PageLoading,
})

export const AsyncSelectClaim = loadable({
  loader: () => import('./SelectClaim').then(({ SelectClaim }) => SelectClaim),
  loading: PageLoading,
})
